/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.search-bar',
        input: '.search-bar__text-input',
        fakeInput: '.search-bar__fake-input',
        overlay: '.search-bar__overlay',
        clearInput: '.search-bar__clear-search-icon',
        searchButton: '.search-bar__cta',
        suggestionList: '.search-bar__suggestion-list',
        errorMessage: '.search-bar__error-message',
        closeOverlay: '.search-bar__overlay-close-btn',
        overlayContainer: '.search-bar__overlay-container',
        overlayInfoWrapper: '.search-bar__overlay-info-wrapper',

    },
    classNames: {
        input: 'search-bar__text-input',
        fakeInputError: 'search-bar__fake-input--error',
        fakeInputFocus: 'search-bar__fake-input--focus',
        suggestionListItem: 'search-bar__suggestion-list-item',
        suggestionListItemLink: 'search-bar__suggestion-list-item-link',
        overlayContainer: 'search-bar__overlay-container--mobile-suggestions',
    },
    htmlElements: {
        highlightingOpeneningTag: '<span style="font-weight: bold;" >',
        highlightingClosingTag: '</span>',
    },
};

export class SearchBar {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
        this.isMobileOrTabletScreen = false;
        this.suggestions = [];
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();
        this._inputValue = '';
    }

    _getDomElements() {
        return {
            $input: this._$rootElement.find(config.selectors.input),
            $fakeInput: this._$rootElement.find(config.selectors.fakeInput),
            $overlay: this._$rootElement.find(config.selectors.overlay),
            $clearInput: this._$rootElement.find(config.selectors.clearInput),
            $searchButton: this._$rootElement.find(config.selectors.searchButton),
            $suggestionList: this._$rootElement.find(config.selectors.suggestionList),
            $errorMessage: this._$rootElement.find(config.selectors.errorMessage),
            $closeOverlay: this._$rootElement.find(config.selectors.closeOverlay),
            $overlayContainer: this._$rootElement.find(config.selectors.overlayContainer),
            $overlayInfoWrapper: this._$rootElement.find(config.selectors.overlayInfoWrapper),
        };
    }

    _addEventListeners() {
        this._getScreenSize();
        this._showClearIconOnDesktopScreens();
        this._clearInput();
        this._searchButtonHandler();
        this._openOverlayOnTabletAndMobileScreens();
        this._closeOverlay();
        this._searchOnEnter();

        $(window).on('resize', () => {
            this._getScreenSize();
        });

        this._elements.$input.on('input', (e) => {
            this._inputValue = e.currentTarget.value;
            this._elements.$fakeInput.removeClass(config.classNames.fakeInputError);
            this._elements.$errorMessage.hide();

            if (this._inputValue.length > 2) {
                this._getSearchSuggestions(this._inputValue);
            } else if (this._inputValue.length === 0) {
                this._elements.$clearInput.hide();
                this._elements.$suggestionList.hide();
            } else {
                this._resetSuggestions();
            }
        });
    }

    _getScreenSize() {
        if (Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm')) {
            this.isMobileOrTabletScreen = true;
        } else {
            this.isMobileOrTabletScreen = false;
        }
    }

    _showClearIconOnDesktopScreens() {
        this._elements.$input.on('input', () => {
            this._elements.$clearInput.show();
        });
    }

    _clearInput() {
        this._elements.$clearInput.on('click', () => {
            this._elements.$input.val('');
            this.suggestions = [];
            this._elements.$suggestionList.hide();
            this._elements.$suggestionList.html('');
            this._elements.$overlayInfoWrapper.show();
            this._elements.$overlayContainer.removeClass(config.classNames.overlayContainer);

            if (!this.isMobileOrTabletScreen) {
                this._elements.$clearInput.hide();
            }

            this._elements.$input.focus();
        });
    }

    _openOverlayOnTabletAndMobileScreens() {
        this._elements.$input.on('click', () => {
            if (this.isMobileOrTabletScreen) {
                this._elements.$overlay.show(250);
                this._elements.$input.focus();
                this._elements.$overlayContainer.addClass(config.classNames.overlayContainer);
                setTimeout(() => {
                    this._elements.$clearInput.show();
                }, 250);
            } else {
                this._elements.$fakeInput.addClass(config.classNames.fakeInputFocus);
            }
        });

        this._elements.$input.focusout(() => {
            this._elements.$fakeInput.removeClass(config.classNames.fakeInputFocus);
        });
    }

    _closeOverlay() {
        this._elements.$closeOverlay.on('click', () => {
            this._elements.$overlay.hide(250);

            if (this.isMobileOrTabletScreen) {
                this._elements.$clearInput.hide();
                this._resetSuggestions();
                this._elements.$input.val('');
            }
        });
    }

    async _getSearchSuggestions(searchVal) {
        const suggestionsAPIUrl = `${this._$rootElement[0].getAttribute('data-suggestions')}?term=${searchVal}`;

        try {
            const filteredList = await this._getData(suggestionsAPIUrl);

            this._resetSuggestions();

            const formattedFilteredList = (typeof (filteredList) === 'string') ? JSON.parse(filteredList) : filteredList;

            if (formattedFilteredList.length === 0) {
                // TODO - ? Error message - no entries found ?
            } else {
                this.suggestions = formattedFilteredList;
                this._highlightingSuggestions(searchVal);
            }
        } catch (err) {
            // console.log(err);
        }
    }

    _resetSuggestions() {
        this.suggestions = [];
        this._elements.$suggestionList.html('');
        this._elements.$suggestionList.hide();
    }

    _getData(url) {
        return $.ajax({
            url,
            type: 'GET',
        });
    }

    _highlightingSuggestions(searchVal) {
        const { suggestions } = this;
        let startIndex = null;
        let endIndex = null;
        const manipulatedStrings = [];

        suggestions.forEach((item) => {
            const lowercasedResultString = item.value.toLowerCase();
            const loweredCaseSearchVal = searchVal.toLowerCase();

            if (lowercasedResultString.indexOf(loweredCaseSearchVal) > -1) {
                const searchValLength = searchVal.length;
                startIndex = lowercasedResultString.indexOf(loweredCaseSearchVal);
                endIndex = startIndex + searchValLength;
                // eslint-disable-next-line max-len
                manipulatedStrings.push(this._createSuggestionItem(this._manipulateString(startIndex, endIndex, item.value), item.value));
            }
        });
        if (manipulatedStrings.length === 0) {
            this._elements.$errorMessage.show();
            this._elements.$fakeInput.addClass(config.classNames.fakeInputError);
        } else {
            this._elements.$suggestionList.append(manipulatedStrings.join(''));
            this._elements.$overlayInfoWrapper.hide();
            $('.search-bar__suggestions').show();
            this._elements.$suggestionList.show();
        }
    }

    _createSuggestionItem(string, value) {
        return `
            <li class="${config.classNames.suggestionListItem}">
                <a href="${this._$rootElement[0].getAttribute('data-search')}?keyword=${value}&action=search&search_mode=website">
                    ${string}
                </a>
            </li>
        `;
    }

    _manipulateString(startIndex, endIndex, string) {
        return `${string.slice(startIndex - startIndex, startIndex)}${config.htmlElements.highlightingOpeneningTag}${string.slice(startIndex, endIndex)}${config.htmlElements.highlightingClosingTag}${string.slice(endIndex)}`;
    }

    // TODO add error message if no results found

    _searchButtonHandler() {
        this._elements.$searchButton.on('click', () => {
            window.open(`${this._$rootElement[0].getAttribute('data-search')}?keyword=${this._inputValue}&action=search&search_mode=website`, '_self');
            this._elements.$errorMessage.hide();
            this._elements.$fakeInput.removeClass(config.classNames.fakeInputError);
        });
    }

    _searchOnEnter() {
        this._elements.$input[0].addEventListener('keypress', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this._elements.$searchButton.click();
            }
        });
    }

    _showHideErrorMessage() {
        if (this.suggestions.length === 0) {
            this._elements.$errorMessage.show();
            this._elements.$fakeInput.addClass(config.classNames.fakeInputError);
        } else {
            this._elements.$errorMessage.hide();
            this._elements.$fakeInput.removeClass(config.classNames.fakeInputError);
        }
    }
}

moduleRegistry.registerModule('SearchBar', SearchBar);
moduleRegistry.autoApplyModule('SearchBar', config.selectors.root);
